// Mobile-specific reasons with shorter descriptions (max 10 words)
const mobileReasons = {
  1: {
    title: "First rule of health club? Check yourself!",
    description:
      "Schedule comprehensive health screenings with doorstep sample collection.",
    image: "/42 reasons images/Book Comprehensive Health Checkups.png",
  },
  2: {
    title: "It takes TWO to tango",
    description: "AI connects you with specialists who actually get you.",
    image: "/42 reasons images/37 - Find the right doctor.png",
  },
  3: {
    title: "Point. Shoot. Approved.",
    description: "AI perfects your forms. Use it. Thank us later.",
    image: "/42 reasons images/14 AI errors.png",
  },
  4: {
    title: "Four-sight into your medical bills",
    description: "See hospital bill future before it happens.",
    image: "/42 reasons images/Cost of Ailment.png",
  },
  5: {
    title: "Five-star specialists at your fingertips",
    description: "If it ends in '-ologist', we've got them.",
    image: "/42 reasons images/42 - Consult specialists.png",
  },
  6: {
    title: "Your SIX-pack starter pack",
    description:
      "Bougie gym without selling your soul. Protein + rent affordable.",
    image: "/42 reasons images/cult.png",
  },
  7: {
    title: "The seventh wonder: Insurance that makes sense",
    description: "Ask about policy, get answers you actually understand.",
    image: "/42 reasons images/18 - Understand your policy in english.png",
  },
  8: {
    title: "Eight AM or PM, doctors on demand",
    description: "When sick, you need help. Not forms. Just doctors.",
    image: "/42 reasons images/Connect with Plum Telehealth.png",
  },
  9: {
    title: "Your wellness wingman",
    description:
      "Protein for gains, activewear for style, snacks for sustenance.",
    image: "/42 reasons images/Perks.png",
  },
  10: {
    title: "Family: can't choose them, but you can cover them",
    description: "Add family members even when they're being... themselves.",
    image: "/42 reasons images/7 Enrollment.png",
  },
  11: {
    title: "Be the family know-it-all",
    description: "Know who's covered with quick tap. No guessing games.",
    image: "/42 reasons images/whos covered.png",
  },
  12: {
    title: "Your health card had a glow-up",
    description: "Download digital ID. Never hold up hospital lines again.",
    image: "/42 reasons images/Access Your Insurer Details & Health ID.png",
  },
  13: {
    title: "Plot twist: Thirteen is your lucky number",
    description: "Track claims real-time. 13 brings transparency luck.",
    image: "/42 reasons images/10 Cashless status.png",
  },
  14: {
    title: "Your phone camera just became profitable",
    description: "Take photo, get money back. Instagram that pays dividends.",
    image: "/42 reasons images/9 Reimbursements.png",
  },
  15: {
    title: "Fifteen megawatt smile guaranteed",
    description: "Premium coverage for your best wingmen: teeth and eyes.",
    image: "/42 reasons images/dental.png",
  },
  16: {
    title: "Sweet sixteen and never paying upfront",
    description: "Walk in, get treated. Someone else pays everything.",
    image: "/42 reasons images/8 Cashless claims.png",
  },
  17: {
    title: "Seventeen steps ahead of 'where's my money?'",
    description: "Real-time updates on your claim status.",
    image: "/42 reasons images/reimbursement_status.png",
  },
  18: {
    title: "Find hospitals that won't bankrupt you",
    description: "Locate cashless hospitals. GPS included for emergencies.",
    image: "/42 reasons images/13 Network Hospitals.png",
  },
  19: {
    title: "Your pharmacist's least favorite app",
    description:
      "Serious prescription discounts. Smile picking up medications.",
    image: "/42 reasons images/Medicines.png",
  },
  20: {
    title: "Your health diary, minus the drama",
    description: "Every claim perfectly organised. Great for taxes, records.",
    image: "/42 reasons images/12 Claims History.png",
  },
  21: {
    title: "Finally 21, time for VIP treatment",
    description: "Award-winning support. Real humans solve problems quickly.",
    image: "/42 reasons images/15 - VIP support.png",
  },
  22: {
    title: "Your 3am thoughts have backup now",
    description: "Licensed therapists 24/7. Mental health crises don't wait.",
    image: "/42 reasons images/mentalhelpHelpline.png",
  },
  23: {
    title: "Thirty-two ways to not Google your symptoms",
    description:
      "Expert wisdom. No WebMD rabbit holes convincing you're dying.",
    image: "/42 reasons images/HealthStory.png",
  },
  24: {
    title: "Health wisdom that's pure 24-carat gold",
    description: "Expert articles without needing medical degree.",
    image: "/42 reasons images/19 - Articles on health.png",
  },
  25: {
    title: "Health is personal",
    description: "Insights tailored to YOUR unique health data and life.",
    image: "/42 reasons images/21 Personalised insights.png",
  },
  26: {
    title: "The wellness cherry on top",
    description: "Discover wellness brands that actually help you succeed.",
    image: "/42 reasons images/Perks.png",
  },
  27: {
    title: "Weekly doses of expert wisdom",
    description: "Wellness sessions with actual experts. No gym fees.",
    image: "/42 reasons images/Join Live Wellness Events.png",
  },
  28: {
    title: "Healthy snacks that taste good",
    description: "Nutritious options that don't feel like punishment.",
    image: "/42 reasons images/tastySnacks.png",
  },
  29: {
    title: "Know your health status in minutes",
    description:
      "Science-backed assessments. Clear wellness picture, no guesswork.",
    image: "/42 reasons images/Assessments.png",
  },
  30: {
    title: "Insurance that fits like a good pair of jeans",
    description: "Plans tailored to YOU. Cookie-cutter doesn't work.",
    image: "/42 reasons images/Personal.png",
  },
  31: {
    title: "Your insurance control center",
    description:
      "From health to life insurance, everything organized beautifully in one place.",
    image: "/42 reasons images/Assessments.png",
  },
  32: {
    title: "Skip the queue, get verified online",
    description: "Digital verification without scanning forty documents.",
    image: "/42 reasons images/Pre-filled KYC.png",
  },
  33: {
    title: "Wellness conversations that matter",
    description: "Interactive sessions making health journey less lonely.",
    image: "/42 reasons images/Join Live Wellness Events.png",
  },
  34: {
    title: "Fill the gaps your HR didn't mention",
    description:
      "Extra protection on company insurance. Comprehensive care coverage.",
    image: "/42 reasons images/STU.png",
  },
  35: {
    title: "What's it gonna take, thirty-six reasons?",
    description:
      "If you're reading this, you're either incredibly thorough or desperately avoiding work. Either way, we're impressed. Seven more reasons to go, you beautiful, curious creature.",
    image: "/42 reasons images/reason35.png",
  },
  36: {
    title: "Protect what matters most",
    description:
      "Term life protecting loved ones. Costs like Netflix subscription.",
    image: "/42 reasons images/Term life.png",
  },
  37: {
    title: "Instant bank account verification",
    description: "Secure penny drop tech. No documents, no delays.",
    image: "/42 reasons images/RI claims.png",
  },
  38: {
    title: "Your health conversations, completely private",
    description: "Consultation completely private. Doctor's ears only.",
    image: "/42 reasons images/private-telehealth.png",
  },
  39: {
    title: "Flash sales for your flash abs",
    description: "Exclusive Drop deals. Loyalty has perks.",
    image: "/42 reasons images/Drops.png",
  },
  40: {
    title: "Professional therapy, personal space",
    description: "Licensed therapists via secure video. Mental health matters.",
    image: "/42 reasons images/Mental Health.png",
  },
  41: {
    title: "Paperwork-free reimbursements",
    description: "Photograph OPD receipts. Outpatient care without homework.",
    image: "/42 reasons images/Plum OPD.png",
  },
  42: {
    title: "Saved the best for last: family support",
    description: "Give family access to amazing features. Share health love.",
    image: "/42 reasons images/DependentLogin.png",
  },
};

export const getMobileReasonData = reasonNumber => {
  return mobileReasons[reasonNumber];
};

export default mobileReasons;
